import { OrderDetailsModal } from "@/features/orders/components/viewOrder/OrderDetailsModal";
import { type History, mapApiResponseToOrders, useQuotation } from "@repo/api";
import { Button, Loading } from "@repo/skapa";
import { t } from "@repo/translation";
import { FlexDiv, ModalSheet } from "@repo/ui";
import { useNavigate } from "react-router-dom";

interface ViewQuotationModalProps {
  isOpen: boolean;
  closeModal: () => void;
  quotationId: string;
  historyEntries?: History[];
  activeTab?: string;
  projectId?: number;
}

export const ViewQuotationModal = ({
  isOpen,
  closeModal,
  quotationId,
  historyEntries,
  activeTab,
  projectId,
}: ViewQuotationModalProps) => {
  const { data, isValidating } = useQuotation(quotationId);
  const navigate = useNavigate();

  const [quotation] = mapApiResponseToOrders(data, quotationId);

  return (
    <ModalSheet
      title={`${t("label.quotation")} - ${quotation?.orderNo ?? quotationId}`}
      visible={isOpen}
      onClose={closeModal}
      onBack={quotation ? closeModal : undefined}
      footer={
        projectId && (
          <Button
            type="primary"
            text={t("action.open_project")}
            onClick={() => navigate(`/opportunity/${projectId}`)}
          />
        )
      }
    >
      {isValidating && (
        <FlexDiv justifyContent="center" alignItems="center">
          <Loading text={t("prompt.loading")} />
        </FlexDiv>
      )}
      {!isValidating && (
        <OrderDetailsModal
          order={quotation}
          historyEntries={historyEntries}
          activeTab={activeTab}
        />
      )}
    </ModalSheet>
  );
};
